module.exports = __webpack_public_path__ + "img/logo.11d11284.png";